define.alias("shared/components/shared/post/secondary/caption-writer/form", "calendar/components/shared/post/secondary/caption-writer/form");